import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import Select from "react-select";
import QuatationServices from "../../../services/QuatationServices";
import QuotationLogModal from './QuatationModal'

const QuatationApproval = () => {

  const [showLogs, setShowLogs] = useState(false);
  const [activePartNo, setActivePartNo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2] = useState(true);

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [sort, setsort] = useState(15);
  const activePag = useRef(0);

  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const [selectedRows, setSelectedRows] = useState({});
  const [selectedQuotes, setSelectedQuotes] = useState({});
  const [expiryMonths, setExpiryMonths] = useState({});

  const options = [
    { value: "5", label: "5" },
    { value: "10", label: "10" },
    { value: "20", label: "20" },
    { value: "50", label: "50" },
    { value: "100", label: "100" }
  ];

  const fetchData = useCallback(async (page = 1) => {
    try {
      setLoading(true);
      const res = await QuatationServices.getGroupedApprovedReplies(page, sort);
      setData(res?.data || []);
      setFilteredData(res?.data || []);
      setTotalRecords(res?.pagination?.totalRecords || 0);
      setTotalPages(res?.pagination?.totalPages || 1);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [sort]);

  useEffect(() => {
    fetchData(1);
  }, [fetchData]);

  useEffect(() => {
    const lower = searchQuery.toLowerCase();
    setFilteredData(
      data.filter(item =>
        item.partNo?.toLowerCase().includes(lower) ||
        item.description?.toLowerCase().includes(lower)
      )
    );
  }, [searchQuery, data]);

  // default expiry = 3 months
  useEffect(() => {
    if (!filteredData.length) return;

    const defaults = {};
    filteredData.forEach(i => defaults[i.partNo] = 3);
    setExpiryMonths(defaults);
  }, [filteredData]);

  // auto select lowest quote
  useEffect(() => {
    if (!filteredData.length) return;

    const auto = {};
    filteredData.forEach(item => {
      if (!item.newQuotes?.length) return;

      const lowest = item.newQuotes.reduce((m, q) =>
        q.rate < m.rate ? q : m
      );

      auto[item.partNo] = {
        supplierId: lowest.supplierId,
        rate: lowest.rate,
        unit: lowest.unit
      };
    });

    setSelectedQuotes(auto);
  }, [filteredData]);

  const handleSelect = (partNo, q) => {
    setSelectedQuotes(p => ({
      ...p,
      [partNo]: {
        supplierId: q.supplierId,
        rate: q.rate,
        unit: q.unit
      }
    }));
  };

  const handleBulkApprove = async () => {
  try {
    const parts = Object.keys(selectedRows).filter(p => selectedRows[p]);

    if (!parts.length) {
      return Swal.fire("Select at least one row");
    }

    const approvals = parts.map(partNo => {
      const selected = selectedQuotes[partNo];
      const months = expiryMonths[partNo];

      if (!selected || !months) {
        throw new Error(`Missing selection for ${partNo}`);
      }

      const expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + Number(months));

      return {
        partNo,
        supplierId: selected.supplierId,
        expiryDate
      };
    });

    await QuatationServices.approveGroupedBulk({ approvals });

    Swal.fire({
      icon: "success",
      title: "Approved",
      text: "Selected rates approved successfully"
    });

    setSelectedRows({});
    fetchData(activePag.current + 1);

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Approval blocked",
      text: err.response?.data?.message || err.message || "Bulk approval failed"
    });
  }
};


  const formatDate = d => {
    if (!d) return "-";
    const x = new Date(d);
    return `${String(x.getDate()).padStart(2, "0")}/${String(x.getMonth() + 1).padStart(2, "0")}/${x.getFullYear()} ${String(x.getHours()).padStart(2, "0")}:${String(x.getMinutes()).padStart(2, "0")}:${String(x.getSeconds()).padStart(2, "0")}`;
  };

 const handleForceExpire = async (partNo, supplierId) => {
  try {
    await QuatationServices.forceExpireRate({
      partNo,
      supplierId
    });

    Swal.fire("Rate expired successfully");
    fetchData(activePag.current + 1);

  } catch (err) {
    Swal.fire(err.response?.data?.message || "Expire failed");
  }
};



 const handleReactivate = async (partNo, supplierId) => {
  try {
    await QuatationServices.reactivateRate({
      partNo,
      supplierId
    });

    Swal.fire({
      icon: "success",
      title: "Reactivated",
      text: "Rate reactivated successfully"
    });

    fetchData(activePag.current + 1);

  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Cannot Reactivate",
      text: err.response?.data?.message || "Reactivation blocked"
    });
  }
};




  return (
    <>
      <QuotationLogModal
        show={showLogs}
        handleClose={() => setShowLogs(false)}
        partNo={activePartNo}
      />

      <div className="row">

        {loading ? (
          <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "200px" }}>
            <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} />
            <p className="mt-3 text-primary fw-semibold">Loading Quotations...</p>
          </div>
        ) : (

          <div className="col-xl-12">

            {/* FILTER */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fas fa-filter me-2" />Filter
                </div>
                <div className="tools">
                  <Link to="#" onClick={() => setOpen(!open)}>
                    <i className="fas fa-angle-up" />
                  </Link>
                </div>
              </div>

              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body row">

                    <div className="col-xl-6">
                      <input
                        className="form-control"
                        placeholder="Search by part no, Description"
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                      />
                    </div>

                    <div className="col-xl-6">
                      <Select
                        value={options.find(o => o.value === sort)}
                        onChange={o => setsort(o.value)}
                        isSearchable={false}
                        options={options}
                        className="custom-react-select"
                      />
                    </div>

                  </div>
                </div>
              </Collapse>
            </div>

            {/* TABLE */}
            <div className="filter cm-content-box box-primary">

              <div className="content-title">
                <div className="cpa">
                  <i className="fa fa-list me-2" />
                  Quotations
                  <span className="badge bg-orange ms-2">{totalRecords}</span>
                </div>
              </div>

              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">

                  <div className="mb-3 text-center">
                    <button className="btn btn-sm btn-success px-4" onClick={handleBulkApprove}>
                      ✔ Approve Selected ({Object.values(selectedRows).filter(Boolean).length})
                    </button>
                  </div>

                  <div className="table-responsive">

                    <table className="table table-bordered table-striped text-nowrap">

                      <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                        <tr>
                          <th>Select</th>
                          <th>Part No</th>
                          <th>Description</th>
                          <th>APPROVED</th>
                          <th>NEW QUOTES</th>
                          <th>EXPIRED</th>
                          <th>Logs</th>
                        </tr>
                      </thead>

                      <tbody>

                        {filteredData.map(item => (

                          <tr key={item.partNo}>

                            <td className="text-center">
                              <input
                                type="checkbox"
                                disabled={!item.newQuotes?.length}
                                checked={!!selectedRows[item.partNo]}
                                onChange={e =>
                                  setSelectedRows(p => ({ ...p, [item.partNo]: e.target.checked }))
                                }
                              />
                            </td>

                            <td>{item.partNo}</td>

                            <td style={{ maxWidth: 220, overflow: "hidden", textOverflow: "ellipsis" }}>
                              {item.description || "-"}
                            </td>

                            {/* APPROVED MULTI */}
                            <td>
                              {item.approved?.length ? (
                                <table className="table table-sm table-bordered mb-0">
                                  <tbody>
                                    {item.approved.map((ap, i) => (
                                      <tr key={i} style={{ background: "#e9f7ff" }}>
                                        <td>₹ {ap.rate}</td>
                                        <td>{ap.unit}</td>
                                        <td>{ap.supplierName}</td>
                                        <td>{formatDate(ap.approvedAt)}</td>
                                        <td>{formatDate(ap.expiryDate)}</td>
                                        {/* 🔴 FORCE EXPIRE ICON */}
                                        <td className="text-center">
                                          <i
                                            className="fa fa-times-circle text-danger"
                                            style={{ cursor: "pointer", fontSize: "18px" }}
                                            title="Force Expire"
                                            onClick={() => handleForceExpire(item.partNo, ap.supplierId)}
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : <span className="text-muted">No approved</span>}
                            </td>

                            {/* NEW */}
                            <td>
                              {item.newQuotes?.length ? (
                                <>
                                  <table className="table table-sm mb-0">
                                    <tbody>
                                      {item.newQuotes.map((q, i) => {
                                        const sel = selectedQuotes[item.partNo]?.rate === q.rate;

                                        return (
                                          <tr key={i} style={sel ? { backgroundColor: "#198754" } : {}}>
                                            <td style={sel ? { color: "#fff", fontWeight: 500 } : {}}>
                                              <input
                                                type="radio"
                                                name={item.partNo}
                                                checked={sel}
                                                onChange={() => handleSelect(item.partNo, q)}
                                              />
                                            </td>
                                            <td style={sel ? { color: "#fff", fontWeight: 500 } : {}}>₹ {q.rate}</td>
                                            <td style={sel ? { color: "#fff", fontWeight: 500 } : {}}>{q.unit}</td>
                                            <td style={sel ? { color: "#fff", fontWeight: 500 } : {}}>{q.supplierName}</td>
                                            <td style={sel ? { color: "#fff", fontWeight: 500 } : {}}>{q.source}</td>
                                            <td style={sel ? { color: "#fff", fontWeight: 500 } : {}}>{formatDate(q.receivedAt)}</td>
                                          </tr>
                                        )
                                      })}


                                    </tbody>
                                  </table>

                                  <div className="d-flex gap-3 mt-2">
                                    {[1, 2, 3, 6, 12].map(m => (
                                      <label key={m}>
                                        <input
                                          type="radio"
                                          name={`exp-${item.partNo}`}
                                          checked={expiryMonths[item.partNo] === m}
                                          onChange={() => setExpiryMonths(p => ({ ...p, [item.partNo]: m }))}
                                        /> {m}M
                                      </label>
                                    ))}
                                  </div>
                                </>
                              ) : <span className="text-muted">No new quotes</span>}
                            </td>

                            {/* EXPIRED */}
                            <td>
                              {item.expired?.length ? (
                                <table className="table table-sm table-bordered mb-0">
                                  <tbody>
                                    {item.expired.map((ex, i) => (
                                      <tr key={i}>
                                        <td>₹ {ex.rate}</td>
                                        <td>{ex.unit}</td>
                                        <td>{ex.supplierName}</td>
                                        <td>{formatDate(ex.expiryDate)}</td>
                                        {/* ♻ REACTIVATE ICON */}
                                        <td className="text-center">
                                          <i
                                            className="fa fa-refresh text-success"
                                            style={{ cursor: "pointer", fontSize: "18px" }}
                                            title="Reactivate"
                                            onClick={() => handleReactivate(item.partNo, ex.supplierId)}
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : <span className="text-muted">No history</span>}
                            </td>

                            <td className="text-center">
                              <i
                                className="fa fa-eye text-primary"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setActivePartNo(item.partNo);
                                  setShowLogs(true);
                                }}
                              />
                            </td>

                          </tr>

                        ))}

                      </tbody>

                    </table>
                  </div>

                </div>
              </Collapse>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default QuatationApproval;
